module.exports = __webpack_public_path__ + "img/微信图片_20210308154657.8923011f.png";